module.exports = __webpack_public_path__ + "static/adminherofree-3e1b679e30b007837ea78f728b902e03.png";